// extracted by mini-css-extract-plugin
export default {"container":"CreatePromoCode_container__fsurC","label":"CreatePromoCode_label__xLtWi","customInput":"CreatePromoCode_customInput__SZCNs"};